import ApiFetcher3 from '../ApiFetcher3';

class SkillBasedLessonApi {
  static getAllBySkillIds(skillIds) {
    const params = {skill_ids: skillIds.join()};
    return ApiFetcher3.get('skill-based-lesson/', params);
  }
}

export default SkillBasedLessonApi;
